module.exports = __webpack_public_path__ + "img/sb.763c0fa8.png";